import { Alert, Button, } from "@nextui-org/react";
import { ExclamationTriangleIcon, BuildingOfficeIcon } from "@heroicons/react/24/outline";
import { useNavigate, useLocation} from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import useSWR from "swr";
import { getFetcher } from "../../services/api";
import RolesAccess from "../../enums/roles";
import { COMPANY_INDEX_PATH } from "../../services/routes";

export default function CompanyDataAlert() {
  const { user, roles } = useAuth();
  const navigate = useNavigate();
  const location = useLocation(); // Tambahkan useLocation jika ingin auto-redirect

  // Hanya tampilkan untuk pengelola
  const isPengelola = roles?.includes(RolesAccess.PENGELOLA);

  const { data: companyData, isLoading } = useSWR(isPengelola && user?.companies?.length > 0 ? `/api/company/find/${user.companies[0].companyId}` : null, getFetcher);

  // Jika bukan pengelola, sedang loading, atau data tidak ada, jangan tampilkan
  if (!isPengelola || isLoading || !user?.companies?.length || !companyData) {
    return null;
  }

  // 1. CEK STATUS KELOLA B3 DI AWAL
  // Jika bernilai true, pastikan alert langsung disembunyikan.
  if (companyData.isTidakMelakukanPengelolaanB3) {
    
    // CATATAN: Jika maksud Anda adalah memaksa user pindah halaman (auto-redirect)
    // secara otomatis ketika kondisi di atas terpenuhi, aktifkan baris di bawah ini.
    // Berhati-hatilah agar tidak terjadi infinite loop.
    //
    //if (location.pathname !== COMPANY_INDEX_PATH) {
    //   navigate(COMPANY_INDEX_PATH);
    //}

    return null; // Alert tidak ditampilkan
  }

  // Periksa field-field required berdasarkan validation
  const checkRequiredFields = () => {
    const company = companyData;
    const requiredFields = [
      "name",
      "penanggungJawab",
      "tipePerusahaan",
      "alamatKantor",
      "telpKantor",
      "faxKantor",
      "emailKantor",
      "npwp",
      "bidangUsaha",
      "jenisPelakuUsaha",
      "latitude",
      "longitude",
      "provinceId",
      "regencyId",
      "districtId",
      "villageId",
    ];

    // Periksa apakah ada field yang kosong/null
    const missingFields = requiredFields.filter((field) => {
      const value = company[field];

      // Khusus untuk tipePerusahaan yang berupa array
      if (field === "tipePerusahaan") {
        return !value || !Array.isArray(value) || value.length === 0;
      }

      return !value || value === "" || value === null || value === undefined;
    });

    // Periksa kondisional field
    // Jika jenisPelakuUsaha = "Berusaha", maka nomorInduk required
    if (company.jenisPelakuUsaha === "Berusaha") {
      if (!company.nomorInduk || company.nomorInduk === "") {
        missingFields.push("nomorInduk");
      }
    }

    // Jika tipePerusahaan includes "Distribusi B3", maka skalaPerusahaan required
    if (company.tipePerusahaan?.includes("Distribusi B3")) {
      if (!company.skalaPerusahaan || company.skalaPerusahaan === "") {
        missingFields.push("skalaPerusahaan");
      }
    }

    return missingFields.length > 0;
  };

  const hasIncompleteData = checkRequiredFields();

  // Jika data sudah lengkap, jangan tampilkan alert
  if (!hasIncompleteData) {
    return null;
  }

  // 2. TOMBOL ARAHAN
  // Mengarahkan ke rute COMPANY_INDEX_PATH saat tombol alert diklik
  const handleNavigateToCompany = () => {
    navigate(COMPANY_INDEX_PATH);
  };

  return (
    <div className="sticky top-16 z-40 p-4 bg-white border-b shadow-sm">
      <Alert
        color="warning"
        variant="faded"
        startContent={<ExclamationTriangleIcon className="size-6" />}
        endContent={
          <Button color="warning" variant="solid" size="sm" startContent={<BuildingOfficeIcon className="size-4" />} onPress={handleNavigateToCompany} className="hidden md:flex">
            Update Data Perusahaan
          </Button>
        }
        className="max-w-none"
      >
        <div className="flex flex-col gap-1">
          <span className="font-semibold">Data Perusahaan Belum Lengkap</span>
          <span className="text-sm">Silakan lengkapi data perusahaan Anda terlebih dahulu untuk dapat menggunakan semua fitur aplikasi.</span>
          {/* Button untuk mobile */}
          <Button color="warning" variant="solid" size="sm" startContent={<BuildingOfficeIcon className="size-4" />} onPress={handleNavigateToCompany} className="mt-2 md:hidden w-full">
            Update Data Perusahaan
          </Button>
        </div>
      </Alert>
    </div>
  );
}
